import React from 'react'

import ResultsLabel from './ResultsLabel'
import PlainSelect from '../form/PlainSelect'
import { useI18N } from '../../../libraries/i18n/hook'

type Props = {
  handleChange: (filter: object ) => void,
  itemsAmount: number,
  options: Array<{ label: string, value: string }>,
  currentValue: string
}
const SortingBar: React.FC<Props> = ({ handleChange, itemsAmount, options, currentValue }) => {
  const { t } = useI18N()
  const onChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    handleChange({ 'sortBy': e.target.value })
  }
  if(itemsAmount === 0) return null
  return (
    <div className='flex justify-between items-center w-full mb-4'>
      <ResultsLabel amount={itemsAmount} />
      <div className='text-black text-xs'>
        <span className='mr-2 opacity-80'>{t('common.sortBy')}</span>
        <PlainSelect options={options} value={currentValue} onChange={onChange} />
      </div>
    </div>
  )
}

export default SortingBar
